import _Promise from '/var/www/html/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import NuxtLoading from './components/nuxt-loading.vue';

import '../node_modules/bootstrap/scss/bootstrap.scss';

import '../node_modules/font-awesome/scss/font-awesome.scss';

import '../assets/style.css';

import '../node_modules/intl-tel-input/build/css/intlTelInput.css';

var layouts = {

  "_assistant": function _assistant() {
    return import('../layouts/assistant.vue' /* webpackChunkName: "layouts/assistant" */).then(function (m) {
      return m.default || m;
    });
  },

  "_default": function _default() {
    return import('../layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(function (m) {
      return m.default || m;
    });
  },

  "_green": function _green() {
    return import('../layouts/green.vue' /* webpackChunkName: "layouts/green" */).then(function (m) {
      return m.default || m;
    });
  },

  "_lp_whoapp": function _lp_whoapp() {
    return import('../layouts/lp_whoapp.vue' /* webpackChunkName: "layouts/lp_whoapp" */).then(function (m) {
      return m.default || m;
    });
  },

  "_purple": function _purple() {
    return import('../layouts/purple.vue' /* webpackChunkName: "layouts/purple" */).then(function (m) {
      return m.default || m;
    });
  }

};

var resolvedLayouts = {};

export default {
  head: { "titleTemplate": "My APP", "meta": [{ "charset": "utf-8" }, { "name": "viewport", "content": "width=device-width, initial-scale=1" }], "link": [{ "rel": "icon", "type": 'image/png', "href": '/favicon.png' }, { "rel": "stylesheet", "href": 'https://api.pcivault.io/pcd/pcd_form.css' }], "build": { "extractCSS": true }, "script": [{ "src": 'https://maps.googleapis.com/maps/api/js?key=AIzaSyABRNVefWrqOTk-iAz8p0Arn96j-hMFB-I' }, { "src": 'https://js.stripe.com/v2/' }, { "src": '/js/utils.js' }, { "src": 'https://code.jquery.com/jquery-2.2.4.min.js' }, { "src": 'https://rawgit.com/vwochnik/jquery-typing/master/dist/jquery.typing.min.js' }, { "src": '//cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js' }, { "src": 'https://cdn.jsdelivr.net/jquery.counterup/1.0/jquery.counterup.min.js' }, { "src": 'https://api.paymentwall.com/brick/build/brick-default.1.5.0.min.js' }, { "src": 'https://api.pcivault.io/pcd/pcd_form.js' }], "style": [] },
  render: function render(h, props) {
    var loadingEl = h('nuxt-loading', { ref: 'loading' });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);

    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [templateEl]);

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },

  data: function data() {
    return {
      layout: null,
      layoutName: ''
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this;
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this;
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
  },
  mounted: function mounted() {
    this.$loading = this.$refs.loading;
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  methods: {
    errorChanged: function errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail();
        if (this.$loading.finish) this.$loading.finish();
      }
    },
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default';
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this = this;

      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default';
      var _layout = '_' + layout;
      if (resolvedLayouts[_layout]) {
        return _Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this.$nuxt) {
          return _this.$nuxt.error({ statusCode: 500, message: e.message });
        }
      });
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/App.js
// module id = ./.nuxt/App.js
// module chunks = 54